import React, { Component } from 'react';
import headerImage from './../images/modules/dashboard.jpg';
import { CPLBanner } from '../../../components/Banner';
export default class DashboardModule extends Component {
    render() {
        return <div className="col-md-12">
            <div className="row banner-wrapper">
                <div className="col-md-12">
                    <CPLBanner
                        img={headerImage}
                        content="Dashboard" />
                </div>
            </div>
        </div>
    }
}